import * as React from "react";

var ItemAsegurado = function ItemAsegurado(props) {
  var itemAsegurado = props.itemAsegurado; // Manejar tanto array como objeto singular

  var items = Array.isArray(itemAsegurado) ? itemAsegurado : itemAsegurado ? [itemAsegurado] : [];

  if (items.length === 0) {
    return /*#__PURE__*/React.createElement("tbody", {
      className: "table-bordered"
    }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
      scope: "row"
    }, "Marca:"), /*#__PURE__*/React.createElement("td", null, "-"), /*#__PURE__*/React.createElement("th", {
      scope: "row"
    }, "Patente:"), /*#__PURE__*/React.createElement("td", null, "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
      scope: "row"
    }, "Materia Asegurada:"), /*#__PURE__*/React.createElement("td", null, "-"), /*#__PURE__*/React.createElement("th", {
      scope: "row"
    }, "Comentarios adicionales:"), /*#__PURE__*/React.createElement("td", null, "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
      colSpan: 4,
      style: {
        backgroundColor: '#f8f9fa',
        fontStyle: 'italic',
        color: '#666'
      }
    }, "Debug: No hay items asegurados disponibles")));
  }

  return /*#__PURE__*/React.createElement("tbody", {
    className: "table-bordered"
  }, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: item.id || index
    }, index > 0 && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
      colSpan: 4,
      style: {
        backgroundColor: '#f8f9fa',
        fontWeight: 'bold'
      }
    }, "Item ", index + 1)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
      scope: "row"
    }, "Marca:"), /*#__PURE__*/React.createElement("td", null, (item === null || item === void 0 ? void 0 : item.brand) || "-"), /*#__PURE__*/React.createElement("th", {
      scope: "row"
    }, "Patente:"), /*#__PURE__*/React.createElement("td", null, (item === null || item === void 0 ? void 0 : item.patente) || "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
      scope: "row"
    }, "Materia Asegurada:"), /*#__PURE__*/React.createElement("td", null, (item === null || item === void 0 ? void 0 : item.materia_asegurada) || "-"), /*#__PURE__*/React.createElement("th", {
      scope: "row"
    }, "Comentarios adicionales:"), /*#__PURE__*/React.createElement("td", null, (item === null || item === void 0 ? void 0 : item.comments) || "-")));
  }));
};

export default ItemAsegurado;